import {
    InstagramOutlined,
    XOutlined,
    FacebookOutlined,
    MailOutlined
} from '@ant-design/icons';
import './footer-section.scss';

export default function FooterSection() {
    const getCurrentYear = () => new Date().getFullYear();
    return(
        <div className="sv-footer-section">
            <footer>
                {/* <p className="sv-footer-section-disclaimer">
                    All readings given by Sense Vibrations are for entertainment purposes only, and no guarantee can be given as to the accuracy of a reading.
                </p> */}
                <div className="sv-footer-section-social">
                    <a href="https://www.instagram.com/">
                        <InstagramOutlined twoToneColor="#f1f1f1" className="sv-footer-section-social-icon" />
                    </a>
                    <a href="https://x.com/">
                        <XOutlined twoToneColor="#f1f1f1" className="sv-footer-section-social-icon" />
                    </a>
                    <a href="https://www.facebook.com/">
                        <FacebookOutlined twoToneColor="#f1f1f1" className="sv-footer-section-social-icon" />
                    </a>
                </div>
                <div className="sv-footer-section-contact">
                    <MailOutlined className="sv-footer-section-contact-icon" />
                    <span>info@sensevibrations.com</span>
                </div>
                <p class="sv-footer-section-copyright">Sense Vibrations © {getCurrentYear()}</p>
            </footer>
        </div>
    );
}